/**
 * Percorre uma lista com CONCORRÊNCIA LIMITADA.
 *
 * Para trabalho assíncrono independente item a item — ler os arquivos de um
 * pacote, por exemplo — esperar um para começar o próximo desperdiça o
 * paralelismo que o navegador já tem. Soltar todos de uma vez troca o problema:
 * traz o pacote inteiro para a memória ao mesmo tempo, e um `.zip` de imagens
 * derruba a aba. O meio é uma janela pequena e fixa.
 *
 * A ordem de ENTRADA é preservada na saída, ainda que a execução intercale.
 */
export async function emLotes<T, R>(
  itens: readonly T[],
  fn: (item: T, indice: number) => Promise<R>,
  limite = 6,
): Promise<R[]> {
  const resultados: R[] = new Array(itens.length);
  let proximo = 0;

  const trabalhador = async () => {
    while (proximo < itens.length) {
      const indice = proximo;
      proximo += 1;
      resultados[indice] = await fn(itens[indice]!, indice);
    }
  };

  await Promise.all(Array.from({ length: Math.min(limite, itens.length) }, trabalhador));

  return resultados;
}
